module.exports = __webpack_public_path__ + "static/media/qrcode.ef1f27e9.png";